import { jsx as _jsx } from "react/jsx-runtime";
import { validateEmailField } from "helperFunctions/validation/validateEmail";
import { Field as FinalField } from "react-final-form";
import { FormattedMessage, useIntl } from "react-intl";
import { CustomInput } from "./CustomInput";
// exported for use in tests
export const emailPlaceHolder = "name@example.com";
export function EmailInput({ required, autoFocus, name, autoComplete, helpBlock, defaultValue, "aria-invalid": ariaInvalid, "aria-errormessage": ariaErrorMessage, }) {
    const intl = useIntl();
    // placeholder can't be an Element, we need to get the actual translated string here
    const placeholder = intl.formatMessage({
        id: "emails.emailPlaceholder",
        defaultMessage: "name@example.com",
        description: "placeholder text for email input",
    });
    function validate(value) {
        if (!value && autoComplete !== undefined) {
            /* Browsers handle auto-completed fields differently. Current Chrome for example seems to often (but not always)
             * fill in the value on-screen, but not tell Javascript about it so the validator doesn't see that a value has
             * been entered, and might show "required", which will confuse the user. As soon as the user clicks anywhere on
             * the page (including on a seemingly disabled submit-button), the validator will run and the error will be
             * cleared.
             *
             * We want to suppress this exact validation error before the user clicks anywhere.
             */
            return undefined;
        }
        return validateEmailField(value);
    }
    return (_jsx(FinalField, { required: required, component: CustomInput, componentClass: "input", type: "email", name: name, autoFocus: autoFocus, autoComplete: autoComplete, placeholder: placeholder, validate: validate, defaultValue: defaultValue, "aria-invalid": ariaInvalid, "aria-errormessage": ariaErrorMessage, 
        // parameters for InputWrapper
        helpBlock: helpBlock, label: _jsx(FormattedMessage, { id: "common.emailAddress", defaultMessage: "Email address", description: "profile email display title" }) }));
}
